import axios from 'axios';
import config from '../config/config';
import tokenUtils from '../utils/token';

const API_URI = config.API_URI;

export async function requestApi(path, method, params) {
    const url = `${API_URI}/${path}`;
    const token = await tokenUtils.getToken();
    
    const headers = {
        'Content-Type': 'application/json',
    };
    
    // N'ajoute le token que s'il existe
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const options = {
        method: method,
        url: url,
        headers: headers,
        data: params,
    };

    try {
        const response = await axios(options);
        // Retourne l'objet response complet pour accéder à status, data, etc.
        return response;
    } catch (error) {
        console.error('Error making API request:', error);
        return error
    }
}

/**
 * Télécharge un fichier CSV depuis l'API
 * @param {string} path - Chemin de l'API
 * @param {string} filename - Nom du fichier à télécharger
 */
export async function uploadFile(file) {
    const url = `${API_URI}/files/upload`;
    const token = await tokenUtils.getToken();

    const formData = new FormData();
    formData.append('file', file);

    const headers = {};
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await axios.post(url, formData, { headers });
    return response.data.url;
}

export async function downloadCsv(path, filename) {
    const url = `${API_URI}/${path}`;
    const token = await tokenUtils.getToken();
    
    const headers = {};
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    try {
        const response = await axios({
            method: 'GET',
            url: url,
            headers: headers,
            responseType: 'blob', // Important pour les fichiers
        });

        // Créer un lien de téléchargement
        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        
        return true;
    } catch (error) {
        console.error('Error downloading CSV:', error);
        throw error;
    }
}
